"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDropCardRequirementsMessage = void 0;
const useDropEvent_1 = require("root/src/client/logic/dropEvent/hooks/useDropEvent");
const useUser_1 = require("root/src/client/logic/userData/hooks/useUser");
const platforms_1 = require("root/src/shared/@types/platforms");
const dropEvent_1 = require("root/src/shared/constants/dropEvent");
const useIsMaxDaresReached_1 = require("root/src/client/logic/dropEvent/hooks/useIsMaxDaresReached");
const useConnectedPlatformsByDares_1 = require("root/src/client/logic/dropEvent/hooks/useConnectedPlatformsByDares");
const providers_1 = require("root/src/shared/constants/providers");
const formatNumberWithCommas_1 = require("root/src/shared/util/formatNumberWithCommas");
const ccvRequiredOffset = 1;
function useDropCardRequirementsMessage(recordId) {
    const { averageCcv, connectedPlatforms } = (0, useUser_1.useUserCreatorData)();
    const connectedPlatformsByDaresPlatform = (0, useConnectedPlatformsByDares_1.useConnectedPlatformsByDares)(recordId);
    const followersCountByPlatforms = (0, useUser_1.useCreatorFollowersCountByPlatform)();
    const dropEvent = (0, useDropEvent_1.useDropEvent)(recordId);
    const isMaxDaresReached = (0, useIsMaxDaresReached_1.useIsMaxDaresReachedByAllUserPlatforms)(recordId);
    const isBrand = (0, useUser_1.useIsBrand)();
    if (isBrand) {
        return { display: false };
    }
    if (!dropEvent) {
        return { display: false };
    }
    const { isAbleToParticipate, ccvBreakpoints, followersBreakpoints, dares, } = dropEvent;
    if (!connectedPlatforms.length) {
        return {
            display: false,
        };
    }
    if (!isAbleToParticipate) {
        return {
            display: true,
            canUserParticipate: false,
            requirements: [dropEvent_1.notAbleToParticipateMessage],
        };
    }
    if (isMaxDaresReached) {
        return {
            display: true,
            canUserParticipate: false,
            requirements: [dropEvent_1.maxDaresReachedMessage],
        };
    }
    if (ccvBreakpoints.length === 0 && followersBreakpoints.length === 0) {
        return {
            display: true,
            canUserParticipate: true,
            requirements: [],
        };
    }
    if (!connectedPlatformsByDaresPlatform.length) {
        const missingPlatforms = (0, useConnectedPlatformsByDares_1.getDaresPlatforms)(dares).map(platform => providers_1.providersLabelMap[platform]);
        return {
            display: true,
            canUserParticipate: false,
            requirements: [`You need connect ${missingPlatforms.join(' or ')} to participate in this drop.`],
        };
    }
    const minCcv = getMinCcvBreakpoint(ccvBreakpoints);
    const minYoutubeFollowers = getMinFollowersBreakpointByPlatform(followersBreakpoints, platforms_1.DarePlatform.YouTube);
    const minTiktokFollowers = getMinFollowersBreakpointByPlatform(followersBreakpoints, platforms_1.DarePlatform.TikTok);
    const userRequirementsMessages = connectedPlatformsByDaresPlatform
        .map((platform) => {
        if (platform === platforms_1.DarePlatform.Twitch && minCcv && minCcv > (averageCcv || 0)) {
            return `${(0, formatNumberWithCommas_1.formatNumberWithCommas)(minCcv)} Twitch CCV`;
        }
        if (platform === platforms_1.DarePlatform.YouTube && minYoutubeFollowers && minYoutubeFollowers > followersCountByPlatforms[platform]) {
            return `${(0, formatNumberWithCommas_1.formatNumberWithCommas)(minYoutubeFollowers)} YouTube Subscribers`;
        }
        if (platform === platforms_1.DarePlatform.TikTok && minTiktokFollowers && minTiktokFollowers > followersCountByPlatforms[platform]) {
            return `${(0, formatNumberWithCommas_1.formatNumberWithCommas)(minTiktokFollowers)} TikTok Followers`;
        }
        return null;
    })
        .filter(item => item);
    const canUserParticipate = userRequirementsMessages.length !== connectedPlatformsByDaresPlatform.length;
    return {
        display: true,
        canUserParticipate,
        requirements: !canUserParticipate
            ? [`You need ${userRequirementsMessages.join(' or ')} to participate in this drop.`]
            : [],
    };
}
exports.useDropCardRequirementsMessage = useDropCardRequirementsMessage;
function getMinFollowersBreakpointByPlatform(followerBreakpoints, platform) {
    const followerBreakpointsByPlatform = followerBreakpoints
        .filter(breakpoint => breakpoint.platform === platform)
        .map(({ followerCount }) => followerCount);
    if (!followerBreakpointsByPlatform.length) {
        return null;
    }
    return Math.min(...followerBreakpointsByPlatform);
}
function getMinCcvBreakpoint(ccvBreakpoints) {
    const ccvCountBreakpoints = ccvBreakpoints.map(({ ccv }) => ccv);
    if (!ccvCountBreakpoints.length) {
        return null;
    }
    return Math.min(...ccvCountBreakpoints) + ccvRequiredOffset;
}
